import React from 'react';
import { Carousel, Card, Avatar } from 'antd';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Tasleem Ahmed",
      title: "Senior Director Crop Subscription – Kynetec",
      quote: "Agcurate's Crop Intelligence Solution has significantly enhanced the precision and consistency of our forecasts…",
      avatar: "TA"
    },
    {
      name: "Hakan Öncü",
      title: "Operational Excellence Executive – Kerevitaş",
      quote: "FieldOps™ simplified our field operations, saving time and resources…",
      avatar: "HO"
    },
    {
      name: "Ramazan Özel",
      title: "TARFAŞ",
      quote: "With FieldOps we reduced inspections by half while boosting data quality.",
      avatar: "RO"
    }
  ];

  const { t } = useTranslation();
  return (
    <div className="py-20 bg-light">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold mb-4">{t('testimonials.title')}</h2>
        </motion.div>

        <Carousel autoplay dots={{ className: 'custom-dots' }}>
          {testimonials.map((testimonial, index) => (
            <div key={index}>
              <Card className="max-w-4xl mx-auto text-center p-8 rounded-2xl shadow-md">
                <Avatar size={80} className="bg-primary text-white text-2xl mb-4">
                  {testimonial.avatar}
                </Avatar>
                <blockquote className="text-lg italic mb-6 text-gray-700">
                  "{testimonial.quote}"
                </blockquote>
                <div>
                  <h4 className="font-semibold text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600">{testimonial.title}</p>
                </div>
              </Card>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Testimonials;
